import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CommonModule, DOCUMENT } from '@angular/common';
import { Directive, ElementRef, Inject, Input, NgModule, OnChanges, Renderer2, SimpleChanges } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { WINDOW } from '@wizbii/angular-utilities';
import { fromEvent } from 'rxjs';

@UntilDestroy()
@Directive({ selector: '[appDropdownPanel]' })
export class DropdownPanelDirective implements OnChanges {
  @Input() dropdownPanelOpen!: boolean;
  @Input() doNotResizeOnChanges!: boolean;

  constructor(
    private readonly element: ElementRef,
    private readonly renderer: Renderer2,
    private readonly breakpointObserver: BreakpointObserver,
    @Inject(WINDOW) private readonly window: any,
    @Inject(DOCUMENT) private readonly document: any
  ) {
    fromEvent(this.window, 'resize', { passive: true })
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this.resizePanel();
        },
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes.dropdownPanelOpen.currentValue && !this.doNotResizeOnChanges) {
      this.resizePanel();
    }
  }

  private resizePanel(): void {
    if (this.breakpointObserver.isMatched([Breakpoints.Handset])) {
      return;
    }

    this.window.setTimeout(() => {
      const panel = this.document.querySelector('.dropdown-panel');

      if (!panel) {
        return;
      }

      this.renderer.setStyle(panel, 'min-width', `${this.element.nativeElement.offsetWidth / 16}rem`);
      this.renderer.setStyle(panel, 'width', `${this.element.nativeElement.offsetWidth / 16}rem`);

      const icon = this.element.nativeElement.children[0];

      if (!icon) {
        return;
      }

      const iconStyle = this.window.getComputedStyle ? this.window.getComputedStyle(icon, null) : icon.currentStyle;
      const iconMarginLeft = parseInt(iconStyle.marginLeft, 10) || 0;
      const iconMarginRight = parseInt(iconStyle.marginRight, 10) || 0;
      const iconWidth = parseInt(icon.offsetWidth, 10) || 0;
      const marginToSet: number = iconWidth + iconMarginLeft + iconMarginRight;

      if (
        Array.from(this.element.nativeElement.children).some((element: any) => element.tagName === 'MAT-FORM-FIELD')
      ) {
        this.renderer.setStyle(panel, 'margin-left', `-${(marginToSet - 16) / 16}rem`);
        return;
      }

      this.renderer.setStyle(panel, 'margin-left', `-${marginToSet / 16}rem`);
    });
  }
}

@NgModule({
  imports: [CommonModule],
  exports: [DropdownPanelDirective],
  declarations: [DropdownPanelDirective],
})
export class DropdownPanelModule {}
